import type { AppThunkAction, AppThunkDispatch } from "./../app.types"
import type { ProfileAction } from "./profile.types"
export const PROFILE_FETCH = "PROFILE_FETCH"
export const PROFILE_LOAD = "PROFILE_LOAD"

export function fetchProfile(): AppThunkAction<void, ProfileAction> {
  return (dispatch: AppThunkDispatch<ProfileAction>) => {
    dispatch({ type: PROFILE_FETCH })
    dispatch(loadProfile())
  }
}

export function loadProfile(): ProfileAction {
  return {
    type: PROFILE_LOAD,
    payload: "8C695A31-65CC-4BF6-017E-08D92C158AA8"
  }
}
